import { PlatformEnv } from '@evc/platform';

import { IStaticFlagsEnvironment } from 'shared-modules-angular/feature-flags';

import { baseEnvironment } from './environment.base';

export const environment: { [key: string]: any } & PlatformEnv & IStaticFlagsEnvironment = {
  ...baseEnvironment,
  /**
   * @deprecated use `deployment` instead
   */
  local: false,
  cloudConnected: true,
  networkSettings: true,
  performanceSettings: true,
  checkLicenseWeb: true,
  licenseType: 'Web',
};
